module.exports = new __parcel__URL__("image_ja.6e1292d2.png").toString();